var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.nowClass,on:{"click":function($event){_vm.change(_vm.value)}}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }